import { Clock, MessageSquare, X } from 'lucide-react';
import ChatSidebarSkeleton from './ChatSidebarSkeleton';

const SidebarRecentInquiries = ({ recentInquiries, isHistoryLoading, onSelectInquiry, onDeleteInquiry, setActiveTab, viewMode, currentUser, isOpen }) => {
    if (!isOpen) return null;

    return (
        <div className="mt-8 flex-1 flex flex-col overflow-hidden">
            <p className="px-4 text-xs font-bold text-gray-400 uppercase tracking-wider mb-3 flex items-center gap-2">
                <Clock size={14} />
                {viewMode === 'admin' ? '전체 최신 질의 내역' : viewMode === 'company' ? '회사 최신 질의 내역' : '나의 최근 질의 내역'}
            </p>
            <div className="space-y-0.5 overflow-y-auto custom-scrollbar pr-2">
                {isHistoryLoading ? (
                    <ChatSidebarSkeleton count={5} />
                ) : recentInquiries.slice(0, 5).map((item) => (
                    <div key={`recent-${item.id}`} className="relative group mx-1">
                        <button
                            onClick={() => onSelectInquiry(item)}
                            className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-gray-600 hover:bg-white hover:shadow-sm hover:text-blue-600 transition-all text-left pr-10"
                        >
                            <MessageSquare size={14} className="text-gray-400 group-hover:text-blue-500 flex-shrink-0" />
                            <span className="truncate font-medium">{item.question}</span>
                        </button>
                        {currentUser && (() => {
                            const role = currentUser.role;
                            if (role === 'R0') return true;
                            if (role === 'R2') return item.company_code === currentUser.company;
                            return String(item.user_id) === String(currentUser.id);
                        })() && (
                            <button
                                onClick={(e) => { e.stopPropagation(); onDeleteInquiry(item.id); }}
                                className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-gray-400 hover:text-red-500 transition-all"
                            >
                                <X size={14} strokeWidth={2.5} />
                            </button>
                        )}
                    </div>
                ))}
                {recentInquiries.length > 0 && (
                    <button
                        onClick={() => setActiveTab('history')}
                        className="w-full text-center mt-2 py-2 text-xs font-bold text-blue-500 hover:text-blue-700 hover:bg-blue-50 rounded-xl transition-all"
                    >
                        + 전체 질의 내역 보기
                    </button>
                )}
            </div>
        </div>
    );
};

export default SidebarRecentInquiries;
